
import EoButton from '../EoButton/EoButton.vue'
import EoSocialButton from '../EoSocialButton/EoSocialButton.vue'
import EoColumn from '../EoColumns/EoColumn.vue'
import EoColumns from '../EoColumns/EoColumns.vue'
import EoContainer from '../EoContainer/EoContainer.vue'
import EoIcon from '../EoIcon/EoIcon.vue'
import EoInput from '../EoInput/EoInput.vue'
import EoNavItem from './EoNavItem/EoNavItem.vue'

export default {
  name: 'EoNav',
  components: {
    EoButton,
    EoSocialButton,
    EoColumn,
    EoColumns,
    EoContainer,
    EoIcon,
    EoInput,
    EoNavItem,
  },
  props: {
    /**
     * Heading for the primary list of items
     */
    headingPrimary: {
      type: String,
      default: 'Primaire items',
    },
    /**
     * Description for the primary list of items
     */
    descriptionPrimary: {
      type: String,
      default: null,
    },
    /**
     * Hyperlinks to show in de primary menu
     */
    itemsPrimary: {
      type: Object,
      default: () => {},
    },
    /**
     * Limit the amount of items shown when collapsed, 
     * using this property will also enable the collapse functionality
     */
    primaryCollapseLimit: {
      type: Number,
      default: null,
    },
    /**
     * Text shown when primary menu is collapsed / expanded
     */
    primaryCollapseToggleText: {
      type: Object,
      default: () => { 
        return {
          collapsed: "Toon meer",
          expanded: "Toon minder",
        }
      },
    },
    /**
     * Heading for the secondary list of items
     */
    headingSecondary: {
      type: String,
      default: 'Ga snel naar...',
    },
    /**
     * Hyperlinks to show in de secondary shortcuts menu
     */
    itemsSecondary: {
      type: Object,
      default: () => {},
    },
    /**
     * Heading for the list of social platforms
     */
    headingSocials: {
      type: String,
      default: 'Volg ons op...',
    },
    /**
     * Hyperlinks to show in de social shortcuts menu
     */
    itemsSocials: {
      type: Object,
      default: () => {},
    },
    /**
     * Overwrite the placeholder inside the search field
     */
    searchPlaceholder: {
      type: String,
      default: 'Zoek door de hele site...',
    },
    /**
     * Render the search bar
     */
    hasSearch: {
      type: Boolean,
      default: true,
    },
    /**
     * Style: default color of the text and icons
     */
    textColor: {
      type: String,
      default: null,
    },
    /**
     * Style: color of some hyperlinks and buttons
     */
    accentColor: {
      type: String,
      default: null,
    },
    /**
     * Style: background color
     */
    color: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      keyword: '',
      hasHover: false,
      hoverItem: { $vnode: { key: null } },
      isPrimaryCollapsed: false,
    }
  },
  computed: {
    classes () {
      return {
        'eo-nav': true,
        'has-hover': this.hasHover,
        ['color--' + this.color]: !!this.color,
      }
    },
    searchButtonTextColor () {
      if (!this.textColor) return 'white'
      const isTextColorDark = this.textColor.includes('black') || this.textColor.includes('grey')
      return isTextColorDark ? 'white' : 'black'
    },
    hyperlinks () {
      return {
        primary: this.normalize(this.itemsPrimary),
        secondary: this.normalize(this.itemsSecondary),
        socials: this.normalize(this.itemsSocials),
      }
    },
    isPrimaryCollapsable () {
      return this.primaryCollapseLimit ? true : false
    },
    primaryCollapse () {
      return this.isPrimaryCollapsed ? this.primaryCollapseLimit : this.hyperlinks.primary.length
    },
    primaryLinks () {
      return this.hyperlinks.primary.slice(0, this.primaryCollapse)
    },
  },
  created () {
    this.isPrimaryCollapsed = this.isPrimaryCollapsable
  },
  methods: {
    showMoreLinks () {
      this.isPrimaryCollapsed = !this.isPrimaryCollapsed
    },
    normalize (items) {
      // Normalize key-value object structure to an array structure
      return items ? Object.entries(items).map(( entry ) => {
        const name = entry?.[0] || null
        const props = entry?.[1] || ''

        if (typeof props == 'string') {
          // Normalise when only an url is provided
          return {
            name,
            url: props,
          }
        } else {
          const { url, icon, expand } = props
          const children = props.children ? this.normalize(entry?.[1]?.children) : null

          return {
            name,
            ...( url && { url }),
            ...( icon && { icon }),
            ...( expand && { expand }),
            ...( children && { children }),
          }
        }
      }) : []
    },
    hoverItemKeyContains (key) {
      if (!this.hoverItem || !this.hoverItem.$vnode.key) return false
      return this.hoverItem.$vnode.key.includes(key)
    },
    emitHover (item) {
      /**
       * Emitted when the user hovers a nav-item.
       * Returns the hovered item.
       * @event hover
       */
      this.hasHover = item !== null
      this.hoverItem = item || { $vnode: { key: null } },
      this.$emit('hover', item)
    },
    emitNavigate (item) {
      /**
       * Emitted when the user clicks on a nav-item.
       * Returns the clicked item.
       * @event navigate
       */
      this.$library.focusReset?.focus()
      this.$emit('navigate', item)
    },
    search () {
      /**
       * Emitted when the user submits the search form.
       * Returns the entered keyword.
       * @event search
       */
      this.$emit('search', this.keyword)

      // Reset the input field
      this.$refs.searchInput.blur()
      this.keyword = ''
    },
  },
}
